<template>
  <div :style="style" ref="lavContainer"></div>
</template>

<script>
import lottie from "lottie-web";
export default {
  name: "VLottie",
  props: {
    options: {
      type: Object,
      required: true
    },
    height: [Number, String],
    width: [Number, String]
  },
  data() {
    return {
      anim: {},
      style: {
        width: this.width ? `${this.width}` : "100%",
        height: this.height ? `${this.height}` : "100%",
        overflow: "hidden"
      }
    };
  },
  mounted() {
    this.anim = lottie.loadAnimation({
      container: this.$refs.lavContainer,
      renderer: "svg",
      loop: this.options.loop || false,
      autoplay: this.options.autoplay || false,
      animationData: this.options.animationData.default
    });
    this.$emit("animCreated", this.anim);
  },
  methods: {
    pause() {
      this.anim.pause();
    },
    play() {
      this.anim.play();
    },
    stop() {
      this.anim.stop();
    },
    destroy() {
      this.anim.destroy();
    }
  }
};
</script>
